// Func = limiting Scope for this file
(function(){

	$(document).ready(function () {
        $('#language').select2();
        $('#language').on('select2:selecting', function(e) {
			changeLanguage(e.params.args.data.id);
		});
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	//full navigation
    const fullnav = document.querySelector('.header__nav-holder');
    const primaryNav = {
        navOpen: document.querySelector('.nav-btn-js'),
        navClose: document.querySelector('.close-btn-js')
    };

    if(fullnav) {
        primaryNav.navOpen.addEventListener('click', function () {
            fullnav.classList.add('expanded');
            document.querySelector('.header__logo').classList.add('white');
        });
        primaryNav.navClose.addEventListener('click', function () {
            fullnav.classList.remove('expanded');
            document.querySelector('.header__logo').classList.remove('white');
        });
    }

	//drop down form
	const formdropdown = document.querySelector('.main-rfp__form');
	const formnav = {
		formOpen: document.querySelector('.request-btn-js'),
        formClose: document.querySelector('.close-form-js')
    };

	if(formdropdown) {
		formnav.formOpen.addEventListener('click', function () {
            formdropdown.classList.add('expanded-form');
			document.querySelector('.main-rfp__form--close-btn').style.display = "block";
        });
        formnav.formClose.addEventListener('click', function () {
            formdropdown.classList.remove('expanded-form');
        });
	}


}());